<template>
  <div
    v-b-popover.hover.topright="'+ Add over time '"
    class="hover-pointer"
    @click="addOvertime(dataOvertime.item.id)"
  >
    {{ dataOvertime.item.over_time_hours }}
  </div>
</template>

<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  name: 'AddOvertime',
  props: {
    dataOvertime: {
      type: Object,
      required: false,
      default: null,
    },
    getAllDataPass: {
      type: Function,
      required: true,
    },
  },
  methods: {
    addOvertime(id) {
      this.$swal.fire({
        title: 'Add Over Time By Hours',
        input: 'number',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: async inputValue => {
          try {
            const githubUrl = `/payslip/${id}/over-time`
            const response = await axios.patch(githubUrl, { over_time_hours: inputValue })
            // SweetAlert2 expects something returned here
            return response.data || { success: true }
          } catch (error) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$swal.showValidationMessage(
              `${errorMessage}`,
            )
            // Return false to satisfy consistent-return
            return false
          }
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      }).then(result => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: 'Added successfully',
            icon: 'success',
          })
          this.getAllDataPass()
        }
      })
    },

  },
}
</script>
